export default "uniform mat4 textureMatrix;\nvarying vec4 vUv;\n\nvoid main() {\n\n	vUv = textureMatrix * vec4( position, 1.0 );\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\n}";
